import TextField from '@material-ui/core/TextField';
import num2persian from 'num2persian';
import { formatNumber } from '../../fns';
import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import { currency } from '../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },
}));

const PriceWithLabel = ({
  position = 'top',
  value = 0,
  showCurrency = true,
  ...rest
}) => {
  const classes = useStyles();
  value = value>=0?value:0;
  let extraLabel =
    position === 'top'
      ? ` - ${num2persian(value)} ${showCurrency ? currency : null}`
      : '';
  return (
    <div className={classes.root}>
      <TextField
        {...rest}
        variant={rest.variant ? rest.variant : 'outlined'}
        fullWidth={rest.fullWidth ? rest.fullWidth : true}
        label={
          rest.label ? rest.label + extraLabel : `مبلغ به تومان ${extraLabel}`
        }
        value={formatNumber(value)}
        inputProps={{ pattern: '[0-9]*' }}
      />
      {position === 'down' ? (
        <FormHelperText error>
          {value
            ? `${num2persian(value)} ${showCurrency ? currency : ''}`
            : null}
        </FormHelperText>
      ) : null}
    </div>
  );
};

export default PriceWithLabel;
